export default __webpack_public_path__ + "static/media/chi2023-slides.574a5f35.pdf";